import { AlertTriangle } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import type { ContactData } from "@/types/contact";

type ConfirmationsSectionProps = {
  contactData: ContactData;
  onContactMetaChange: (
    field: "confirmaExactitate" | "acceptaObligatii",
    value: boolean
  ) => void;
  fieldErrors: Record<string, string>;
};

function CheckboxError({ error }: { error: string | undefined }) {
  if (!error) return null;

  return (
    <div className="flex items-center gap-2 mt-1 ml-6">
      <AlertTriangle className="h-3.5 w-3.5 text-destructive shrink-0" />
      <span className="text-xs text-destructive">{error}</span>
    </div>
  );
}

function ConfirmationsSection({
  contactData,
  onContactMetaChange,
  fieldErrors,
}: ConfirmationsSectionProps) {
  return (
    <div className="space-y-3 py-4">
      <div>
        <div className="flex items-start gap-2">
          <Checkbox
            id="confirma-exactitate"
            checked={contactData.confirmaExactitate}
            onCheckedChange={(checked) =>
              onContactMetaChange("confirmaExactitate", !!checked)
            }
          />
          <Label
            htmlFor="confirma-exactitate"
            className="text-xs leading-tight cursor-pointer"
          >
            Confirm exactitatea datelor completate{" "}
            <span className="text-destructive">*</span>
          </Label>
        </div>
        <CheckboxError error={fieldErrors["confirmaExactitate"]} />
      </div>

      <div>
        <div className="flex items-start gap-2">
          <Checkbox
            id="accepta-obligatii"
            checked={contactData.acceptaObligatii}
            onCheckedChange={(checked) =>
              onContactMetaChange("acceptaObligatii", !!checked)
            }
          />
          <Label
            htmlFor="accepta-obligatii"
            className="text-xs leading-tight cursor-pointer"
          >
            Accept obligațiile conform NIS2{" "}
            <span className="text-destructive">*</span>
          </Label>
        </div>
        <CheckboxError error={fieldErrors["acceptaObligatii"]} />
      </div>
    </div>
  );
}

export default ConfirmationsSection;
